<template>
    <div class="history">
        <el-dialog title="发卡记录" :visible.sync="dialogVisible" width="1200px" :before-close="handleClose">
            <div class="form">
                <el-form :inline="true" :model="formInline" class="demo-form-inline">
                    <el-form-item>
                        <el-input v-model="formInline.name" placeholder="请输入用户名" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="getCategoryList">查 询</el-button>
                        <!-- <el-button type="primary" @click="reset">重 置</el-button> -->
                    </el-form-item>
                </el-form>
            </div>
            <div class="table" v-loading="load">
                <el-table :data="classTable" style="width: 100%" border>
                    <el-table-column width="140px" align="center" prop="id" show-overflow-tooltip label="ID"> </el-table-column>
                    <el-table-column width="180px" align="center" prop="title" show-overflow-tooltip label="福利卡名称"> </el-table-column>
                    <el-table-column width="180px" align="center" prop="moneys" show-overflow-tooltip label="面额"> </el-table-column>
                    <el-table-column width="200px" align="center" prop="card_sn" label="卡号"> </el-table-column>
                    <el-table-column width="140px" align="center" prop="amount" label="数量">
                        <template>1</template>
                    </el-table-column>
                    <el-table-column width="200px" align="center" prop="create_time" label="发卡时间"> </el-table-column>
                    <el-table-column width="140px" align="center" prop="nicknames" label="发放对象"> </el-table-column>
                    <el-table-column width="140px" align="center" prop="is_normal" label="状态">
                        <template slot-scope="{ row }">
                            {{ row.is_normal == 1 ? "正常" : "已过期" }}
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <div class="pageList">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="page"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="size"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                    background
                >
                </el-pagination>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
    data() {
        return {
            page: 1,
            size: 10,
            total: 0,
            classTable: [],
            dialogVisible: false,
            load: false,
            formInline: {
                name: "",
            },
            id: "",
        };
    },
    computed: {
        ...mapGetters({
            getToken: "getToken",
        }),
    },
    methods: {
        ...mapActions({
            couponsRecorde: "detect/couponsRecorde",
        }),
        handleClose() {
            this.dialogVisible = false;
            this.formInline = {
                name: "",
            };
            this.id = "";
        },
        getCategoryList() {
            this.load = true;
            let params = {
                token: this.getToken,
                card_id: this.id,
                nicknames: this.formInline.name,
                page: this.page,
                page_size: this.size,
            };
            this.couponsRecorde(params).then(({ data }) => {
                this.load = false;
                if (data.code == 1) {
                    this.classTable = data.data.data;
                    this.total = data.data.count;
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        handleSizeChange(val) {
            this.size = val;
            this.getCategoryList();
        },
        handleCurrentChange(val) {
            this.page = val;
            this.getCategoryList();
        },
    },
};
</script>

<style lang="scss" scoped>
.history {
    .link {
        a {
            margin: 0 8px;
        }
    }
}
.red {
    color: #fb7369;
}
.pageList {
    text-align: right;
    margin-top: 20px;
}
.table {
    height: 450px;
    overflow: auto;
}
</style>